import { render, staticRenderFns } from "./aplicacion-nomina.vue?vue&type=template&id=435bce82&"
import script from "./aplicacion-nomina.vue?vue&type=script&lang=ts&"
export * from "./aplicacion-nomina.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports